import { Form, Modal, message } from "antd"
import React from "react"
import SelectCustomer from "src/components/Dropdown/SelectCustomer"
import axios from "axios"
import AffiliateService from "src/services/AffiliateService"

const ModalCreateAffiliateAcc = ({ open, onCancel, onSuccess }) => {
  const [form] = Form.useForm()
  const handleOk = async () => {
    try {
      const values = await form.validateFields()
      // Gọi API để tạo tài khoản affiliate
      await AffiliateService.addAccountAffiliate({
        user_id: values.affiliate_account,
      })
      message.success("Tạo tài khoản affiliate thành công!")
      form.resetFields()
      onCancel()
      onSuccess?.()
    } catch (error) {
      console.error(error)
      message.error("Tạo tài khoản affiliate thất bại!")
    }
  }

  return (
    <Modal
      title="Tạo tài khoản affiliate"
      open={open}
      width={600}
      onCancel={onCancel}
      onOk={handleOk}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="affiliate_account"
          label="Chọn tài khoản affiliate"
          rules={[{ required: true, message: "Vui lòng chọn tài khoản" }]}
        >
          <SelectCustomer type="STAFF" />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default ModalCreateAffiliateAcc
